// extracted by mini-css-extract-plugin
export default {"modal":"loadingScreen_modal__eiAgq","modalContent":"loadingScreen_modalContent__NDi5R","loadingContainer":"loadingScreen_loadingContainer__pd6s-"};